import './ccf-chat-inbound.module.scss';
import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfChatInboundProps  {}
/**
 * component used to display chat inbound icon 
 * @param props - CcfChatInboundProps
 * @example - <CcfChatInbound />
 * @returns SVG of chat inbound icon
 */
export function CcfChatInbound(props: CcfChatInboundProps) {
  return (
    <SvgIcon viewBox="0 0 18 16.714" {...props}>
      <path
        className="a"
        d="M129.678-42h-5.356A6.3,6.3,0,0,0,118-35.726v.108a6.3,6.3,0,0,0,6.322,6.274H126.9l5.519,3.964a.561.561,0,0,0,.59.02.545.545,0,0,0,.269-.464L132.453-30A6.252,6.252,0,0,0,136-35.615v-.108A6.3,6.3,0,0,0,129.678-42Z"
        transform="translate(-118 42)"
      />
    </SvgIcon>
  );
}

export default CcfChatInbound;
